module.exports = __webpack_public_path__ + "static/media/everyday_bundle_hero.feb5a909.png";